{
  "tagsContent": [
    {
      "title": "主题",
      "content": ["山水", "人物", "花鸟"]
    },
    {
      "title": "朝代",
      "content": [
        "先秦",
        "汉代",
        "魏晋南北朝",
        "隋唐",
        "五代十国",
        "宋代",
        "元代",
        "明代",
        "清代",
        "近现代"
      ]
    },
    {
      "title": "类型",
      "content": ["工笔", "写意", "兼工带写"]
    },
    {
      "title": "材质",
      "content": ["纸本", "绢本", "其他"]
    },
    {
      "title": "形制",
      "content": ["立轴", "条屏", "中堂", "横幅", "长卷", "册页", "扇面", "镜片"]
    },
    {
      "title": "画派",
      "content": [
        "人物-",
        "曹家",
        "吴家",
        "龙眠派",
        "老莲派",
        "十洲派",
        "山水-",
        "南宗",
        "北宗",
        "北宋三家",
        "宋初三家",
        "米派（二米）",
        "南宋四大家",
        "元四大家",
        "明四大家",
        "四僧",
        "画中九友",
        "金陵八家",
        "四王",
        "清初六大家",
        "浙江画派",
        "黄山画派",
        "江西画派",
        "画中十哲",
        "花鸟-",
        "黄家",
        "徐家",
        "湖州竹派",
        "眉山竹派",
        "常州派",
        "新罗派",
        "扬州八怪",
        "海派",
        "海派四杰",
        "京派",
        "岭南画派",
        "大写意派",
        "折衷派（岭南三杰）",
        "二居",
        "勾花点叶派",
        "张松顾柳",
        "其他-",
        "画家四祖",
        "六朝四大家"
      ]
    }
  ]
}
